import {
  Page,
  Document,
  PDFViewer,
  View,
  Text,
  StyleSheet,
} from "@react-pdf/renderer";
import { numberWithDecimals } from "../../utils/validate";
// import { Request } from "../../hooks/Request";

const styles = StyleSheet.create({
  page: {
    padding: "20px 20px",
    fontSize: 8.5,
  },
  seccion: {
    marginTop: 20,
    marginHorizontal: 30,
  },
  title: {
    fontSize: 14,
    textAlign: "right",
    marginBottom: 10,
    fontWeight: 500,
    letterSpacing: 0.5,
  },
  datos: {
    flexDirection: "col",
    alignItems: "flex-end",
  },
  detalle: {
    width: 300,
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 2,
    gap: 10,
  },
  label: {
    width: 100,
    textAlign: "right",
    marginTop: 1,
    fontWeight: "semibold",
    flex: 1
  },
  value: {
    flex: 1,
    wordBreak: "break-word",
    textAlign: "right",
    marginTop: 1,
    flex: 2
  },
  row: {
    flexDirection: "row",
    gap: 80,
  },
  column: {
    flex: 1,
  },
  rows: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 2,
  },
  text1: { fontWeight: "bold", marginBottom: 1, paddingLeft: 2, paddingTop: 2 },
  text2: { marginBottom: 1, paddingLeft: 2 },
  table: {
    marginTop: 4,
    borderColor: "#000",
    borderStyle: "solid",
  },
  tableRowHeader: {
    flexDirection: "row",
    backgroundColor: "#c6c6c6",
    borderRadius: 2,
  },
  cell: {
    flex: 1,
    padding: 3,
    textAlign: "right",
    borderColor: "#000",
    borderStyle: "solid",
    fontWeight: "bold",
  },
  tableRow: {
    flexDirection: "row",
    minHeight: 28,
    borderColor: "#000",
    borderStyle: "solid",
  },
  cellRow: {
    flex: 1,
    padding: 3,
    textAlign: "right",
    fontWeight: "normal",
    alignSelf: "center",
  },
  footer: {
    position: "absolute",
    bottom: 40,
    left: 0,
    right: 20,
    textAlign: "center",
  },

});

const data = {
  cliente: {
    cliente: "razonSocial", // cliente: "data.company.razonSocial",
    nit: "nit",  // nit: "data.company.nit",
    direccion: "direccion", // direccion:" data.company.direccion",
    ciudad: "ciudad", // ciudad: "data.company.ciudad",
    contacto: "phone", // contacto: "data.company.phone",
  },
  Importador: {
    numero: "2025-0038",
    fecha: "16/06/2025",
    hojaTrabajo: "SCZ-2025-0038",
    nombreBanco: "BANCO UNION",
    cuentaBanco: "1045331464",
    declaracion: "-",
    facturaComercial: "B2407874-E",
    proformaPrveedor: "HJ-W-DM240805",
    nombre: "DAIMOMOTORSCORPORACION S.R.L.",
    numerDespacho: "-",
    dim: "-",
  },
  tabla: [
    {
      cantidad: "185",
      pu: "100",
      descripcion:
        "Honorarios y servicios (Logistica Aduanera - Servicio de Operaciones A.)",
      saldo: "",
      importeCobrar: "18500",
    },
    {
      cantidad: "1",
      pu: "150",
      descripcion: "Servicio de Stickers",
      saldo: "",
      importeCobrar: "150",
    },
    {
      cantidad: "1",
      pu: "2009.35",
      descripcion: "Saldo de Conciliacion a Favor del Importador",
      saldo: "2009.35",
      importeCobrar: "",
    },
  ],
};

function CustomsClearanceCollectionNote() {
  const MyDoc = ({ data }) => {
    return (
      <Document>
        <Page size="LETTER" style={styles.page}>
          <View style={styles.seccion}>
            <Text style={styles.title}>
              NOTA DE COBRANZA DE DESPACHO{"\n"}ADUANERO
            </Text>
            <View style={{ ...styles.row }}>
              <View style={{ ...styles.column, marginTop: 15 }}>
                <Text
                  style={{
                    ...styles.text1,
                    backgroundColor: "#F2F2F2",
                    paddingBottom: 2,
                  }}
                >
                  Cliente
                </Text>
                <Text style={[{ ...styles.text2, }, { height: 25 }]}>
                  {data.cliente.cliente}
                </Text>
                <Text style={styles.text1}>Nit:</Text>
                <Text style={styles.text2}>{data.cliente.nit}</Text>
                <Text style={styles.text1}>Direccion:</Text>
                <Text style={styles.text2}>{data.cliente.direccion}</Text>
                <Text style={styles.text1}>Ciudad:</Text>
                <Text style={styles.text2}>{data.cliente.ciudad}</Text>
                <Text style={styles.text1}>Contacto:</Text>
                <Text style={styles.text2}>{data.cliente.contacto}</Text>
              </View>
              <View style={styles.datos}>
                <View style={styles.detalle}>
                  <Text style={styles.label}>Nº</Text>
                  <Text style={styles.value}>{data.Importador.numero}</Text>
                </View>
                <View style={styles.detalle}>
                  <Text style={styles.label}>Hoja de Trabajo:</Text>
                  <Text style={styles.value}>{data.Importador.hojaTrabajo}</Text>
                </View>
                <View style={styles.detalle}>
                  <Text style={styles.label}>Fecha:</Text>
                  <Text style={styles.value}>{data.Importador.fecha}</Text>
                </View>
                <View style={styles.detalle}>
                  <Text style={styles.label}>
                    N° de Factura Comercial Proveedor:
                  </Text>
                  <Text style={styles.value}>
                    {data.Importador.facturaComercial}
                  </Text>
                </View>
                <View style={styles.detalle}>
                  <Text style={styles.label}>
                    Proforma Proveedor / Pedido / Orden:
                  </Text>
                  <Text style={styles.value}>
                    {data.Importador.proformaPrveedor}
                  </Text>
                </View>
                <View style={styles.detalle}>
                  <Text style={styles.label}>
                    N° De Planilla de Despacho Aduanero:
                  </Text>
                  <Text style={styles.value}>
                    {data.Importador.numerDespacho}
                  </Text>
                </View>
                <View style={styles.detalle}>
                  <Text style={styles.label}>N° De DIM:</Text>
                  <Text style={styles.value}>{data.Importador.dim}</Text>
                </View>
                <View style={styles.detalle}>
                  <Text style={styles.label}>Importador:</Text>
                  <Text style={{ ...styles.value, fontWeight: 600 }}>
                    {data.Importador.nombre}
                  </Text>
                </View>
              </View>
            </View>
          </View>

          <View style={styles.seccion}>
            <View style={styles.table}>
              <View style={styles.tableRowHeader}>
                <Text style={{ ...styles.cell, flex: 1, textAlign: "center" }}>
                  Cant.
                </Text>
                <Text style={{ ...styles.cell, flex: 1, textAlign: "center" }}>
                  P/U
                </Text>
                <Text style={{ ...styles.cell, flex: 6, textAlign: "left" }}>
                  Concepto
                </Text>
                <Text style={{ ...styles.cell, flex: 2 }}>
                  Saldo de{"\n"}conciliación Bs
                </Text>
                <Text style={{ ...styles.cell, flex: 2 }}>
                  Importe Por{"\n"}Cobrar Bs
                </Text>
              </View>
              {data.tabla.concat([...Array(2)]).map((item, index) => (
                <View
                  key={index}
                  style={{
                    ...styles.tableRow,
                    backgroundColor: index % 2 === 0 ? "#fff" : "#f0f0f0",
                  }}
                >
                  <Text
                    style={{ ...styles.cellRow, flex: 1, textAlign: "center" }}
                  >
                    {item?.cantidad || ""}
                  </Text>
                  <Text
                    style={{ ...styles.cellRow, flex: 1, textAlign: "center" }}
                  >
                    {numberWithDecimals(Number(item?.pu) || "")}
                  </Text>
                  <Text
                    style={{ ...styles.cellRow, flex: 6, textAlign: "left" }}
                  >
                    {item?.descripcion || ""}
                  </Text>
                  <Text style={{ ...styles.cellRow, flex: 2 }}>
                    {item?.saldo ? numberWithDecimals(Number(item.saldo)) : ""}
                  </Text>
                  <Text style={{ ...styles.cellRow, flex: 2 }}>
                    {item?.importeCobrar
                      ? numberWithDecimals(Number(item.importeCobrar))
                      : ""}
                  </Text>
                </View>
              ))}
            </View>
          </View>
          <View style={{ ...styles.seccion }}>
            <View style={{ flexDirection: "row", padding: 2 }}>
              <View style={{ alignItems: "flex-end", gap: 2, flex: 8 }}>
                <Text>Suma Bs:</Text>
                <Text>Saldo de Conciliación a favor del importador:</Text>
                <Text>
                  {" "}
                  Total a favor de SCZPLUS Agencia despachante de Aduana s.r.l.:
                </Text>
              </View>
              <View style={{ alignItems: "flex-end", gap: 2, flex: 2 }}>
                <Text>
                  {numberWithDecimals(
                    Number(data?.tabla[0]?.importeCobrar || "")
                  )}
                </Text>
                <Text>
                  {numberWithDecimals(Number(data?.tabla[2]?.pu || ""))}
                </Text>
                <Text>
                  {numberWithDecimals(
                    Number(
                      data?.tabla[0]?.importeCobrar - data?.tabla[2]?.pu || ""
                    )
                  )}
                </Text>
              </View>
            </View>
          </View>
          <View style={styles.footer}>
            <View style={{ ...styles.seccion }}>
              <View style={{ flexDirection: "row", padding: 2 }}>
                <View style={{ alignItems: "flex-end", flex: 1 }}>
                  <Text>BANCO UNION</Text>
                  <Text>CZPLUS AGENCIA DESPACHANTE DE ADUANA S.R.L.</Text>
                  <Text>Cuenta N° 1000045331464 en Bolivianos</Text>
                  <Text>NIT: 452143024</Text>
                </View>
              </View>
            </View>
          </View>
        </Page>
      </Document>
    );
  };
  return (
    <div>
      {data && (
        <PDFViewer
          style={{
            width: 900,
            height: window.innerHeight - 100,
          }}
        >
          <MyDoc data={data} />
        </PDFViewer>
      )}
    </div>
  );
}

export default CustomsClearanceCollectionNote;
